<template>
  <div class="date-range">
    <div class="date-timer">
      <div class="timer-left">
        <p>{{ $t('startText') }}</p>
      </div>
      <div class="timer-right" @click="selectDate('startTime')">
        <p>{{ startText }}</p>
        <img :src="Chevron" alt="select">
      </div>
    </div>
    <div class="date-timer">
      <div class="timer-left">
        <p>{{ $t('endText') }}</p>
      </div>
      <div class="timer-right" @click="selectDate('endTime')">
        <p>{{ endText }}</p>
        <img :src="Chevron" alt="select">
      </div>
    </div>
    <div
      :class="chooseList.length >3 ? 'date-choose-row' : 'date-choose'">
      <div
        v-for="(item, index) in chooseList"
        :key="index"
        @click="changeRange(index, item.rangeDate)"
        :class="[
          'date-choose-item',
          index === activeIndex ? 'data-choose-active' : 'data-choose-inactive'
        ]">
        <p>{{ item.text }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { Chevron_Blue } from '@/images'
import moment from '@/utils/moment'
import { DateTime } from '@/components'
const { getDayRange, getMonthRange, fmMDY } = moment
export default {
  props: {
    initNum: {
      type: Number,
      default: 1 // [0, 1, 2]
    },
    startDate: {
      type: String,
      default: ''
    },
    endDate: {
      type: String,
      default: ''
    },
    initEmit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      Chevron: Chevron_Blue,
      startTime: '',
      endTime: '',
      activeIndex: -1
    }
  },
  computed: {
    startText () {
      return this.startTime || this.$t('selectText')
    },
    endText () {
      return this.endTime || this.$t('selectText')
    },
    chooseList () {
      if (Array.isArray(this.provideChooseList)) {
        return this.provideChooseList
      } else {
        return [
          {
            text: this.$t('nearlyAWeeks'),
            rangeDate: getDayRange(7)
          },
          {
            text: this.$t('nearlyThreeMonths'),
            rangeDate: getMonthRange(3)
          },
          {
            text: this.$t('nearlySixMonths'),
            rangeDate: getMonthRange(6)
          }
        ]
      }
    }
  },
  inject: {
    provideChooseList: {
      default: ''
    }
  },
  watch: {
  },
  created () {
    // console.log('DateRange created')
    this.initData()
  },
  methods: {
    emitTime () {
      this.$emit('dateRange', {
        startTime: this.startTime,
        endTime: this.endTime
      })
    },
    changeRange (index, rangeDate) {
      const { startTime, endTime } = rangeDate
      this.startTime = startTime
      this.endTime = endTime
      this.activeIndex = index
      // console.log('this.startTime', this.startTime)
      this.emitTime()
    },
    selectDate (key) {
      DateTime({
        title: key === 'startTime' ? this.$t('selectStartText') : this.$t('selectEndText'),
        maxDate: key === 'startTime' ? this.endTime : '',
        minDate: key === 'startTime' ? '' : this.startTime,
        errorText: this.$t('rangeError'),
        date: this[key]
      })
        .then(data => {
          this[key] = data.date
          this.activeIndex = -1
          this.emitTime()
        })
    },
    initData () {
      // 优先判断activeIndex选项
      if (this.initNum !== -1 && this.initNum !== void 0) {
        this.activeIndex = this.initNum
        this.changeRange(this.activeIndex, this.chooseList[this.activeIndex].rangeDate)
      } else {
        this.startTime = this.startDate && fmMDY(this.startDate)
        this.endTime = this.endDate && fmMDY(this.endDate)
        this.activeIndex = -1
      }
      if (this.initEmit) {
        this.emitTime()
      }
    },
    retDate () {
      this.initData()
    }
  }
}
</script>

<style lang="scss" scoped>
.date-range {
  width: 315px;
  padding: 0 15px;
  background-color: $color-stage1;
  p {
    font-size: $span-font-size;
  }
  .date-timer {
    @include border-bottom;

    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    height: 50px;
    .timer-left {
      width: 140px;
      p {
        color: $color-text;
        line-height: 20px;
      }
    }
    .timer-right {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-end;
      width: 160px;
      p {
        color: $color-primary;
      }
      img {
        width: 16px;
        height: 16px;
      }
    }
  }
  .date-choose {
    display: flex;
    flex-direction: row;
    padding: 15px 0;
    .date-choose-item {
      display: flex;
      flex: 1;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      padding: 0 15px;
      line-height: 20px;
      p {
        text-align: center;
      }
      &:nth-child(n + 2) {
        @include border-left;
      }
    }
  }
  // 子元素一行排两个
  .date-choose-row {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
    padding: 15px 0;
    .date-choose-item {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      width: 48%;
      line-height: 20px;
      p {
        text-align: center;
      }
      &:nth-child(2n + 1) {
        @include border-right;
      }
      &:nth-child(n + 3) {
        margin-top: 15px;
      }
    }
  }
  .data-choose-active {
    color: $color-primary;
  }
  .data-choose-inactive {
    color: $color-stage4;
  }
}
</style>
